/**
 * Font Size Application Utility
 * Functions to apply font size presets to the document
 */

/**
 * Apply font size to document root via CSS variable
 * @param fontSize - Font size value (e.g., "1rem", "0.75rem", "1.25rem")
 */
export function applyFontSize(fontSize: string): void {
  if (typeof document === 'undefined') return
  
  const root = document.documentElement
  // Set CSS variable for base font size
  root.style.setProperty('--base-font-size', fontSize)
  root.setAttribute('data-font-size', fontSize)
  
  // Also apply directly to html element for immediate effect
  root.style.fontSize = fontSize
}

/**
 * Clear font size and reset to default
 */
export function clearFontSize(): void {
  if (typeof document === 'undefined') return
  
  const root = document.documentElement
  root.style.removeProperty('--base-font-size')
  root.style.removeProperty('font-size')
  root.removeAttribute('data-font-size')
}

/**
 * Get current font size from document
 * @returns Current font size value or null if not set
 */
export function getCurrentFontSize(): string | null {
  if (typeof document === 'undefined') return null
  
  const root = document.documentElement
  const fontSize = root.style.getPropertyValue('--base-font-size') || root.style.fontSize
  return fontSize || null
}

